var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"ru:file-control"},[_vm._t("default"),_vm._v(" "),_c('input',{ref:"fileControl",attrs:{"type":"file","accept":_vm.accept,"multiple":_vm.multiple},on:{"change":_vm.filesChange}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }